import React from 'react';

export const DocumentText: React.FC<{ text?: string }> = ({text}) => {
    return (
            <div style={{width: "95%", height: "95%", marginLeft: 'auto', marginRight: 'auto', display: 'block', overflowY: "scroll", whiteSpace: 'pre-line'}}>
                <p>{text}</p>
            </div>
    );
}
